import { action, observable, makeObservable } from "mobx";
import StockAPI from "../api/StockAPI";
import {
  Product,
  Stock,
  StockCheckSuggestedProducts,
} from "../models/Stock/Stock";
import { GetStockParams } from "../models/Stock/GetStockParams";
import { OrderProduct } from "../models/Order/OrderProduct";

export class StockStore {
  stockAPI: StockAPI;
  limit: number;
  total_pages: number;
  total_count: number;
  stocks: Stock[];
  orderStockCheckReqDetails: Stock[];
  stockCheckReq: Stock;
  eligibleProducts: OrderProduct[];
  useManualVendorEntry: boolean;
  vendorSearchInput: string;

  constructor() {
    this.stockAPI = new StockAPI();
    this.stocks = [];
    this.limit = 0;
    this.total_pages = 0;
    this.total_count = 0;
    this.orderStockCheckReqDetails = [];
    this.stockCheckReq = {};
    this.eligibleProducts = [];
    this.useManualVendorEntry = false;
    this.vendorSearchInput = "";

    makeObservable(this, {
      stocks: observable,
      getStockList: action,
      getStockListByOrderId: action,
      orderStockCheckReqDetails: observable,
      raiseStockCheckRequest: action,
      updateStockCheckRequest: action,
      updateStatus: action,
      useManualVendorEntry: observable,
      vendorSearchInput: observable,
      setUseManualVendorEntry: action,
      setVendorSearchInput: action,
    });
  }

  getStockList = async (params: GetStockParams) => {
    try {
      this.stocks = [];
      const response = await this.stockAPI.getStockList(params);
      this.limit = response.limit;
      this.total_pages = response.total_pages;
      this.total_count = response.total_count;
      this.stocks = response.list;
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  getStockListByOrderId = async (orderId: number) => {
    try {
      const response = await this.stockAPI.getStockListByOrderId(orderId);
      this.orderStockCheckReqDetails = response;
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  getEligibleProducts = async (orderId: number): Promise<void> => {
    try {
      this.eligibleProducts = [];
      this.eligibleProducts = await this.stockAPI.getEligibleProductsByOrderId(
        orderId
      );
    } catch (error: any) {
      throw error;
    }
  };

  raiseStockCheckRequest = async (orderId: number, products: Product[]) => {
    try {
      await this.stockAPI.raiseStockCheckRequest(
        orderId,
        products
      );
    } catch (error: any) {
      throw error;
    }
  };

  updateStockCheckRequest = async (
    orderId: number,
    requestId: number,
    options: {
      status?: number;
      products?: Product[];
      suggestedProducts?: StockCheckSuggestedProducts[];
    }
  ) => {
    try {
      const { status, products, suggestedProducts } = options;
      let response;
      if (status !== undefined) {
        response = await this.stockAPI.updateStockCheckRequest(
          orderId,
          requestId!,
          {
            status,
          }
        );
      } else {
        response = await this.stockAPI.updateStockCheckRequest(
          orderId,
          requestId!,
          {
            products,
            suggestedProducts,
          }
        );
      }
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  updateStatus = (requestId: number, status: number) => {
    this.orderStockCheckReqDetails.forEach((req) => {
      if (req.id === requestId) {
        req.status = status;
      }
    });
  };

  setUseManualVendorEntry = (value: boolean) => {
    this.useManualVendorEntry = value;
  };

  setVendorSearchInput = (value: string) => {
    this.vendorSearchInput = value;
  };
}
